import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bank--statement-entries"
// Selection on the PDF statement review table: select-all, live count, and a submit
// button that stays disabled while nothing is picked.
//
// The generic table-interactions controller is deliberately NOT reused here: it restores
// its own selection state on connect, which would wipe the server-rendered defaults (rows
// flagged as duplicates come pre-unchecked on purpose).
export default class extends Controller {
  static targets = ["selectAll", "rowCheckbox", "selectedCount", "submitButton"]

  connect() {
    this.update()
  }

  toggleAll(event) {
    const checked = event.currentTarget.checked
    // Duplicate-flagged rows are deliberately excluded from select-all: importing one is an
    // override of a warning, so it has to be a per-row decision, never a sweep.
    for (const checkbox of this.enabledCheckboxes) {
      if (checkbox.dataset.duplicate === "true") continue
      checkbox.checked = checked
    }
    this.update()
  }

  update() {
    const boxes = this.enabledCheckboxes
    const selected = boxes.filter((checkbox) => checkbox.checked)

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = selected.length
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = selected.length === 0
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = boxes.length > 0 && selected.length === boxes.length
      this.selectAllTarget.indeterminate = selected.length > 0 && selected.length < boxes.length
    }
  }

  get enabledCheckboxes() {
    return this.rowCheckboxTargets.filter((checkbox) => !checkbox.disabled)
  }
}
